// /Users/boyd/Dev/freegopos/my-web-app/src/pages/MyInvois/DashBoard.tsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// Import necessary API functions and types
import {
    fetchMyinvoisCredentials,
    // fetchSeller, // Assuming fetches seller ID 1 or relevant seller
    // fetchCustomer,
    // fetchInvoiceItems
} from '../../utils/MyInvois/api';
import { useTranslation } from 'react-i18next';
import { MyinvoisCredentials, Invoice, InvoiceItem } from '../../utils/MyInvois/types';
// import { Seller, Customer } from '../../utils/types';
import { toast } from 'react-toastify';
import { useMyinvois } from '../../context/MyinvoisContext';
import MyinvoisConnection from '../../components/MyInvois//MyinvoisConnection';
import MyinvoisGetDocs from '../../components/MyInvois//MyinvoisGetDocs';
import MyinvoisBuyer from '../../components/MyInvois//MyinvoisBuyer';
import MyinvoisSeller from '../../components/MyInvois//MyinvoisSeller';
import MyinvoisInvoice from '../../components/MyInvois//MyinvoisInvoice';
import MyinvoisListDocs from '../../components/MyInvois//MyinvoisListDocs';

const DashBoard: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        fetchMyinvoisCredentials();
    })

    return (
        <div>
            <h1>{t('myinvois.dashboard')}</h1>
        </div>
    );
};
export default DashBoard